import type { Config } from "./interfaces";
import { easingList } from "./easing";

export const CONFIG: Config = {
	duration: 1000,
	interval: 10,
	easing: easingList.linear,
	accuracy: 0.001,
};
